import {
  getSubLandingPageContainer,
  withInviterLoading,
} from '../SubLandingPage';
import FamilySubLandingPage from 'components/SubLandingPage/Family';
import { withFamily } from 'data/plan/withPlan';

export const FamilySubLandingPageContainer =
  withInviterLoading(FamilySubLandingPage);
export default withFamily(getSubLandingPageContainer(FamilySubLandingPage));
